<via-error>
  <h1>
    {{ "errors.fatal_error.title" | transloco }}
  </h1>
  <a [routerLink]="['/record-interview']">Try again</a>
  <via-back-to-dashboard-button>
    {{ "button.home" | transloco }}
  </via-back-to-dashboard-button>
</via-error>
